// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2040R","track":"styles__track___3IVtD","dot":"styles__dot___ec-g9","selected":"styles__selected___360aY"};